var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{ref:"mainNavbar",scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('DefaultNavbar',{attrs:{"navitems":_vm.menu},on:{"close":_vm.handleClose}})]},proxy:true}])}),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }